import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  TopScrollBar: {
    flexGrow: 1,
    width: '100%',
    background: 'rgba(2, 7, 20, 1)',
    position: 'fixed',
    top: 60,
    zIndex: 100,
    '& .MuiTabScrollButton-root': {
      display: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      width: '50%',
      marginLeft: '22%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
      marginLeft: '23%',
    },
  },
  TopScrollBarInner: {
    padding: '0 12px',
  },
}));
